var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 157,
    viewBox: "0 0 129 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0248 111.146C14.2221 100.319 5.35416 83.4867 5.35416 64.5833C5.35416 31.9181 31.8348 5.4375 64.5 5.4375C97.1652 5.4375 123.646 31.9181 123.646 64.5833C123.646 83.4867 114.778 100.319 100.975 111.146C99.8563 115.667 98.5927 120.005 97.5956 123.251C96.5289 126.724 93.6443 129.248 90.0312 129.625C85.1826 130.132 77.0097 130.688 64.5 130.688C51.9903 130.688 43.8174 130.132 38.9688 129.625C35.3557 129.248 32.4711 126.724 31.4044 123.251C30.4073 120.005 29.1437 115.667 28.0248 111.146Z",
    fill: "#EDE3CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3659 129.539C39.0708 134.097 39.8056 138.245 40.4207 141.521C41.286 146.13 44.564 149.832 49.2011 150.534C52.8406 151.084 57.8966 151.56 64.5 151.56C70.7799 151.56 75.9399 151.13 79.8685 150.614C85.3806 149.891 89.2418 145.306 89.8405 139.779L90.9566 129.477C90.6543 129.541 90.3454 129.59 90.0312 129.623C85.1826 130.129 77.0101 130.685 64.5 130.685C51.9903 130.685 43.8174 130.129 38.9692 129.623C38.7657 129.602 38.5646 129.574 38.3659 129.539Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0248 111.146C14.2221 100.319 5.35416 83.4867 5.35416 64.5833C5.35416 31.9181 31.8348 5.4375 64.5 5.4375C97.1652 5.4375 123.646 31.9181 123.646 64.5833C123.646 83.4867 114.778 100.319 100.975 111.146C99.8563 115.667 98.5927 120.005 97.5956 123.251C96.5289 126.724 93.6443 129.248 90.0312 129.625C85.1826 130.132 77.0097 130.688 64.5 130.688C51.9903 130.688 43.8174 130.132 38.9688 129.625C35.3557 129.248 32.4711 126.724 31.4044 123.251C30.4073 120.005 29.1437 115.667 28.0248 111.146Z",
    stroke: "#92570E",
    strokeWidth: 10.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3659 129.539C39.0708 134.097 39.8056 138.245 40.4207 141.521C41.286 146.13 44.564 149.832 49.2011 150.534C52.8406 151.084 57.8966 151.56 64.5 151.56C70.7799 151.56 75.9399 151.13 79.8685 150.614C85.3806 149.891 89.2418 145.306 89.8405 139.779L90.9566 129.477",
    stroke: "#92570E",
    strokeWidth: 10.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2917 61.1042C99.2917 41.8894 83.7147 26.3125 64.5 26.3125",
    stroke: "#92570E",
    strokeWidth: 10.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.3afff54a38eb7eea47f9b2a3449cda61.svg";
export { ForwardRef as ReactComponent };